import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const AddProject = () => {
  const [projId,setProjId]=useState("");
    const [labs, setLabs] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [contributors, setContributors] = useState([]);
    const [formData, setFormData] = useState({
        proj_id: '',
        proj_doc_upload: '',
        proj_initial_fund: '',
        proj_summary: '',
        proj_title: '',
        proj_type: '',
        proj_utilization: '',
        trl_level: '',
        lab_id: '',
        proj_start_date: '',
        proj_end_date: '',
        proj_Keyword: '',
        patent_id: '',
        pub_id: '',
        selectedDepartments: [],
        selectedContributors: [],
    });

    const [error, setError] = useState('');
    const navigate = useHistory();


  //   useEffect(() => {
  //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects/next-id`)
  //         .then(response => setProjId(response.data))
  //         .catch(error => console.error("Error fetching project ID:", error));
  // }, []);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects/next-id`)
      .then(res => {
        setFormData(prev => ({
          ...prev,
          projId: res.data
        }));
      })
      .catch(err => console.error("ID fetch failed", err));
  }, []);

    useEffect(() => {
        const getLabs = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/researchlabs`);
                setLabs(response.data);
            } catch (error) {
                setError("Failed to fetch labs.");
            }
        };

        const getDepartments = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/departments`);
                setDepartments(response.data);
            } catch (error) {
                setError("Failed to fetch departments.");
            }
        };

        const getContributors = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users`);
                setContributors(response.data);
            } catch (error) {
                setError("Failed to fetch contributors.");
            }
        };

        getLabs();
        getDepartments();
        getContributors();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDepartmentChange = (e, index) => {
        const { value } = e.target;
        const updatedDepartments = [...formData.selectedDepartments];
        updatedDepartments[index] = value;
        setFormData({ ...formData, selectedDepartments: updatedDepartments });
    };

    const handleContributorChange = (e, index) => {
        const { value } = e.target;
        const updatedContributors = [...formData.selectedContributors];
        updatedContributors[index] = value;
        setFormData({ ...formData, selectedContributors: updatedContributors });
    };

    const addDepartmentField = () => {
        if (formData.selectedDepartments.length < 6) {
            setFormData({
                ...formData,
                selectedDepartments: [...formData.selectedDepartments, ''],
            });
        }
    };

    const addContributorField = () => {
        if (formData.selectedContributors.length < 6) {
            setFormData({
                ...formData,
                selectedContributors: [...formData.selectedContributors, ''],
            });
        }
    };

    const removeDepartmentField = (index) => {
        const updatedDepartments = [...formData.selectedDepartments];
        updatedDepartments.splice(index, 1);
        setFormData({
          ...formData,
          selectedDepartments: updatedDepartments,
        });
      };
      
      const removeContributorField = (index) => {
        const updatedContributors = [...formData.selectedContributors];
        updatedContributors.splice(index, 1);
        setFormData({
          ...formData,
          selectedContributors: updatedContributors,
        });
      };
    

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const projectData = {
                projId: formData.projId,
                projTitle: formData.projTitle,
                projSummary: formData.projSummary,
                projUtilization: formData.projUtilization,
                projInitialFund: formData.projInitialFund,
                projDocUpload: formData.projDocUpload,
                projStartDate: formData.projStartDate,
                projEndDate: formData.projEndDate,
                projType: formData.projType,
                labId: formData.labId,
                trlLevel: formData.trlLevel,
                projKeyword: formData.projKeyword
            };

            const projectResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/projects`, projectData);
            const projId = projectResponse.data.projId;

            const departmentData = {
                projId,
                departments: formData.selectedDepartments.map(deptId => ({ deptId })),
            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/project-departments`, departmentData);

            const contributorData = {
                projId,
                contributors: formData.selectedContributors.map(userId => ({ userId })),
            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/project-contributors`, contributorData);
    
            // Add project outcome data submission here
            const outcomeData = {
                projId,
                patentId: formData.patentId,
                pubId: formData.pubId
            };
    
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/project_outcomes`, outcomeData);
    
            alert("Project and its related data added successfully!");

        } catch (error) {
            alert("Error adding project or its related data. Please try again.");
        }
    };

    const handleEdit = () => {
        const projId = prompt("Enter Project ID to Edit:");
        if (projId) {
            navigate.push(`/editproject/${projId}`);
        }
    };

    return (
        <div className="container mt-4">
            <form onSubmit={handleSubmit}>
            <h2 className="text-center m-4">Add a Project</h2>
               
                
                <div className="row mb-3">
                <div className="col-md-6">
                <label>Project ID</label>
             <span style={{ color: 'red', fontSize: '20px', marginLeft: "2px" }}>*</span>
<input
  type="text"
  value={formData.projId}
  disabled
  className="form-control"
/>
        </div>
                    <div className="col-md-6">
                        <label className="form-label">Title:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                        <input type="text" className="form-control" name="projTitle" onChange={handleChange} />
                    </div>
                </div>

                <div className="row mb-3">
                <div className="col-md-6">
  <label className="form-label">Summary:(in 200 words)</label>
  <textarea
    className="form-control"
    name="projSummary"
    rows="5" // Adjust the number of rows as needed
    onChange={handleChange}
  ></textarea>
</div>
                    <div className="col-md-6">
                        <label className="form-label">Type:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                        <select className="form-select" name="projType" onChange={handleChange} >
                            <option value="">Select a project type</option>
                            <option value="Externally Funded">Externally Funded</option>
                            <option value="Internally Funded">Internally Funded</option>
                            <option value="Consultancy">Consultancy</option>
                            <option value="Funded Programme">Funded Programme</option>
                           
                        </select>
                    </div>
                </div>

                <div className="row mb-3">
                <div className="col-md-6">
  <label className="form-label">TRL Level:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
  <select
    className="form-select"
    name="trlLevel"
    onChange={handleChange}
  >
    <option value="">Select TRL Level</option>
    <option value="1">1 - Basic Principles Observed</option>
    <option value="2">2 - Technology Concept Formulated</option>
    <option value="3">3 - Experimental Proof of Concept</option>
    <option value="4">4 - Technology Validated in Lab</option>
    <option value="5">5 - Technology Validated in Relevant Environment</option>
    <option value="6">6 - System Prototype Demonstrated in Relevant Environment</option>
    <option value="7">7 - System Prototype Demonstrated in Operational Environment</option>
    <option value="8">8 - System Completed and Qualified</option>
    <option value="9">9 - Actual System Proven in Operational Environment</option>
  </select>
</div>
                    {/*<div className="col-md-6">
                        <label className="form-label">Document:</label>
                        <input type="text" className="form-control" name="projDocUpload" onChange={handleChange} />
                    </div>*/}
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Initial Fund:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                        <input type="text" className="form-control" name="projInitialFund" onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Utilization:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                        <input type="text" className="form-control" name="projUtilization" onChange={handleChange} />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Lab:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                        <select className="form-select" name="labId" onChange={handleChange} >
                            <option value="">Select a lab</option>
                            {labs.map(lab => (
                                <option key={lab.labId} value={lab.labId}>{lab.labName}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Start Date:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                        <input type="date" className="form-control" name="projStartDate" onChange={handleChange}  />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">End Date:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                        <input type="date" className="form-control" name="projEndDate" onChange={handleChange} />
                    </div>
                </div>
                <div className="col-md-6">
                        <label className="form-label">Enter a Keyword for your Project:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                        <input type="text" className="form-control" name="projKeyword" onChange={handleChange} />
                    </div>
                    <div className="row mb-3">
                 <div className="col-md-6">
        <label className="form-label">Patent ID:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
        <input type="text" className="form-control" name="patentId" onChange={handleChange} />
    </div>
    <div className="col-md-6">
        <label className="form-label">Publication ID:  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
        <input type="text" className="form-control" name="pubId" onChange={handleChange} />
    </div>
</div>

                    
<h5>Departments  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></h5>
<div className="d-flex flex-wrap">
  {formData.selectedDepartments.map((department, index) => (
    <div key={index} className="d-flex align-items-center mb-2 me-3">
      <select
        className="form-select me-2"
        value={department}
        onChange={(e) => handleDepartmentChange(e, index)}
      >
        <option value="">Select a department</option>
        {departments.map((dept) => (
          <option key={dept.deptId} value={dept.deptId}>
            {dept.deptName}
          </option>
        ))}
      </select>
      <button
        type="button"
        className="btn btn-outline-danger btn-sm"
        onClick={() => removeDepartmentField(index)}
      >
        Remove
      </button>
    </div>
  ))}
</div>
<button
  type="button"
  
    className="btn me-2"
    style={{ backgroundColor: 'rgba(0, 123, 255, 0.2)', color: 'black', border: 'none' }}
  onClick={addDepartmentField}
>
  Add Department
</button>

<h5 className="mt-4">Contributors  <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></h5>
<div className="d-flex flex-wrap">
  {formData.selectedContributors.map((contributor, index) => (
    <div key={index} className="d-flex align-items-center mb-2 me-3">
      <select
        className="form-select me-2"
        value={contributor}
        onChange={(e) => handleContributorChange(e, index)}
      >
        <option value="">Select a contributor</option>
        {contributors.map((contrib) => (
          <option key={contrib.userId} value={contrib.userId}>
            {contrib.username}
          </option>
        ))}
      </select>
      <button
        type="button"
        className="btn btn-outline-danger btn-sm"
        onClick={() => removeContributorField(index)}
      >
        Remove
      </button>
    </div>
  ))}
</div>
<button
  type="button"
    className="btn me-2"
    style={{ backgroundColor: 'rgba(0, 123, 255, 0.2)', color: 'black', border: 'none' }}
  onClick={addContributorField}
>
  Add Contributor
</button>

<div className="d-flex justify-content-end mt-3">
  <button
    type="submit"
    className="btn me-2"
    style={{ backgroundColor: 'rgba(0, 123, 255, 0.2)', color: 'black', border: 'none' }}
  >
    Submit
  </button>
  {/* <button
    type="button"
    className="btn me-2"
    style={{ backgroundColor: 'rgba(0, 123, 255, 0.2)', color: 'black', border: 'none' }}
    onClick={handleEdit}
  >
    Edit Existing Project
  </button> */}
</div>
            </form>
        </div>
    );
};

export default AddProject;
